import { FormControl, NG_VALIDATORS } from '@angular/forms';
import { Directive, Input } from '@angular/core';
import Validator from 'validator';

@Directive({
    selector: '[floEmail]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: EmailDirective, multi: true },
    ],
})
export class EmailDirective {
    @Input() public allowMultiple: boolean = false;
    private formControl: FormControl;

    public validate(control: FormControl): { [s: string]: boolean } {
        this.formControl = control;

        if (control.value) {
            if (this.allowMultiple) {
                const re: RegExp = / /g;
                const trimmedValue: string = control.value.replace(re, '');
                const emails: string[] = trimmedValue.split(',');

                for (let idx: number = 0; idx < emails.length; idx++) {
                    if (!Validator.isEmail(emails[idx])) {
                        return { invalidEmail: true };
                    }
                }
            } else if (!Validator.isEmail(control.value)) {
                return { invalidEmail: true };
            }
        }

        return null;
    }
}
